import { useSizing } from 'hooks/useSizing';
import { theme } from 'lib/theme';
import React from 'react';
import { View } from 'react-native';
import DraggableFlatList, {
  DraggableFlatListProps,
} from 'react-native-draggable-flatlist';

type Props<T> = {
  // data: unknown[];

  // scrollIndicatorInsets?: Insets;
  // scrollEnabled?: boolean;
  // children: React.ReactNode;
  // keyboardAvoiding?: boolean;
  // contentContainerStyle?: StyleProp<ViewStyle>;
  // backgroundColor?: string;
  contentPaddingTop?: number;
  contentPaddingBottom?: number;
  withoutSafeAreaBottom?: boolean;

  data: DraggableFlatListProps<T>['data'];
  renderItem: DraggableFlatListProps<T>['renderItem'];
  keyExtractor: DraggableFlatListProps<T>['keyExtractor'];
  onDragEnd?: DraggableFlatListProps<T>['onDragEnd'];
  contentContainerStyle?: DraggableFlatListProps<T>['contentContainerStyle'];
};

export const PageListDraggable = <T,>({
  contentContainerStyle,
  contentPaddingTop = theme.padding * 2,
  contentPaddingBottom = theme.padding * 2,
  withoutSafeAreaBottom,
  data,
  renderItem,
  onDragEnd,
  keyExtractor,
}: Props<T>): React.ReactElement => {
  const { headerHeight, safeAreaBottom, safeAreaLeft, safeAreaRight } =
    useSizing();

  const paddingTop = (headerHeight || 0) + contentPaddingTop;
  const paddingBottom =
    (withoutSafeAreaBottom ? 0 : safeAreaBottom) + contentPaddingBottom;

  return (
    <DraggableFlatList
      // Required for web to drag
      activationDistance={1}
      data={data}
      renderItem={renderItem}
      keyExtractor={keyExtractor}
      onDragEnd={onDragEnd}
      contentContainerStyle={[
        {
          paddingTop,
          paddingBottom,
          paddingLeft: safeAreaLeft,
          paddingRight: safeAreaRight,
        },
        contentContainerStyle,
      ]}
      ItemSeparatorComponent={() => (
        <View style={{ height: theme.padding / 2 }} />
      )}
      containerStyle={{ flex: 1 }}
      scrollEnabled={true}
    />
  );
};
